import { emailRegex, phoneRegex } from "../../components/common/Helpers/Validations";
import * as yup from "yup";

import React from "react";
import { Col, Container, Row } from "reactstrap";
import { Box } from "@mui/material";
import { PageHeader } from "../../components/common/PageHeader/PageHeader";
import { CMForm } from "../../components/common/Form/CMForm";
import { editPatient, getByPatientId } from "./PatientServices";
import PatientTable from "./PatientTable/PatientTable";
import { PropaneSharp } from "@mui/icons-material";

export const formFields: any = [
    {
        label: "Patient Name",
        type: 'text',
        name: 'firstname',
        placeholder: 'Enter First Name',
    },
    {
        label: "Father / Mother / Spouse Name",
        type: 'text',
        name: 'fathername',
        placeholder: 'Enter Father Name',
    },
    {
        label: "Aadhar Number",
        type: 'number',
        name: 'aadhar_number',
        placeholder: 'Enter Total Amount',
    },
    {
        label: "Contact Number",
        type: 'text',
        name: 'contact_number',
        placeholder: 'Enter Contact Number',
    },
    {
        label: "Height",
        type: 'text',
        name: 'height',
        placeholder: 'Enter Height',
    },
    {
        label: "Weight",
        type: 'text',
        name: 'weight',
        placeholder: 'Enter Weight',
    },
    {
        label: "BP",
        type: 'text',
        name: 'bp',
        placeholder: 'Enter BP',
    },
    {
        label: "SPO2",
        type: 'text',
        name: 'sp02',
        placeholder: 'Enter SPO2',
    },
    {
        label: "Fever",
        type: 'text',
        name: 'fever',
        placeholder: 'Enter Fever',
    },
    {
        label: "First register",
        type: 'date',
        name: 'first_register',
        placeholder: 'Enter First Register',
    },
    {
        label: "Revisit",
        type: 'date',
        name: 'revisit',
        placeholder: 'Enter Revisit',
    },
]

export const validationSchema = yup.object({
    firstname: yup.string().required(" First Name is required!"),
    fathername: yup.string().required(" Father Name is required!"),
    aadhar_number: yup.string().required(" Aadhar Number is required!"),
    contact_number: yup.string().required(" Contact Number is required!"),
    height: yup.string().required(" Height is required!"),
    weight: yup.string().required(" Weight is required!"),
    bp: yup.string().required(" BP is required!"),
    sp02: yup.string().required(" SPO2 is required!"),
    fever: yup.string().required(" Fever is required!"),
    first_register: yup.date().required(" First Register is required!"),
    revisit: yup.date().required(" Revisit is required!"),
});

export const PatientEdit = () => {
console.log("PatientEdit")
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row>
                        <Col lg={12}>
                            <Box component="div" sx={{ mt: 2 }}>
                                <PageHeader header="Edit Patient" />
                                {/* <CMForm
                                    validationSchema={validationSchema}
                                    formFields={formFields}
                                    addService={editPatient}
                                    listPageKey='PATIENT_LIST'
                                    type="edit"
                                    detailService={getByPatientId}
                                /> */}
                                <PatientTable />
                            </Box>
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    )
}
